import Config from '@/config';

export default (slug) => slug ?
  Object.values(Config.INSURANCE_TYPES_SELECT)
    .find(({ slug: cSlug }) => cSlug.toLowerCase() === slug?.toLowerCase())
    ?.value || null
  : null;
